
    var riot = require('riot')
    
riot.tag2('chat', '<div if="{active}"> <h4> <a onclick="{deactivate}" class="close">&times</a>Chat </h4> <div class="chatlist"> <ul class="list-unstyled"> <li each="{messages}" class="{user_id ? \'\' : \'me\'}"> <div class="imageblock"><img riot-tag="img_loader" default="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCA4MCA4MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNNDAuMDgsNzguMzc3YzExLjA0OCwwLjAyMSAyMS43MTQsLTQuMDk4IDI5Ljg4LC0xMS41NGMwLjUxMywtMC40ODUgMC44MDUsLTEuMTYyIDAuODA1LC0xLjg2OWMwLC0wLjkyMSAtMC40OTUsLTEuNzc0IC0xLjI5NSwtMi4yMzFjLTQuNTc5LC0yLjUzNyAtOS41LC00LjM5OSAtMTQuNjEsLTUuNTNjLTAuMDk2LC0wLjAyNCAtMC4xNjMsLTAuMTEyIC0wLjE2LC0wLjIxbDAsLTNjMS43NjEsLTIuMjk5IDMuMDc3LC00LjkwNyAzLjg4LC03LjY5YzIsLTIgMi44OSwtNS4xMSAzLjM2LC02LjhjMC43OCwtMi43NCAxLjU2LC02LjcxIC0wLjU5LC05LjU1bC0wLjA5LC0wLjEyYzEsLTUgMi4zMiwtMTYuNzUgLTYuNjIsLTIyLjcxYzEuMDQ2LC0xLjA2NCAxLjYxNywtMi41MDggMS41OCwtNGMtMC4wMTEsLTAuMTQ0IC0wLjA3OSwtMC4yNzggLTAuMTksLTAuMzdjLTAuMTEzLC0wLjA5IC0wLjI1NywtMC4xMzMgLTAuNCwtMC4xMmMtMC4xMSwwIC0xMS4zLDEuMjcgLTE2LjY4LDAuMTZjLTUuMzgsLTEuMTEgLTExLjYsMy4wNSAtMTIuODUsNy4zNWMtMi4wODksMC4yNzMgLTMuOTkxLDEuMzUgLTUuMywzYy0yLjQ0LDMgLTMuMTksNy44IC0yLjIyLDE0LjIzYzAuMDYsMC44MyAwLjE3LDEuNjQgMC4zMSwyLjQ4bC0wLjEsMC4xMmMtMi4xMywyLjc4IC0xLjM1LDYuNzYgLTAuNTcsOS40OWMwLjQ4LDEuNjkgMS4zNiw0LjgyIDMuMzYsNi43OWMwLjgsMi44MDQgMi4xMiw1LjQzMyAzLjg5LDcuNzVsMCwzYzAuMDAyLDAuMDk4IC0wLjA2NSwwLjE4NiAtMC4xNiwwLjIxYy01LjEwMywxLjEyNiAtMTAuMDE3LDIuOTgyIC0xNC41OSw1LjUxYy0wLjgsMC40NTcgLTEuMjk2LDEuMzEgLTEuMjk2LDIuMjMxYzAsMC43MDcgMC4yOTIsMS4zODQgMC44MDYsMS44NjljOC4xNTYsNy40MzkgMTguODEsMTEuNTYxIDI5Ljg1LDExLjU1bDAsMFpNNDAuMDgsNjguMDA3Yy00LjczLDAuMDUzIC05LjIwNSwtMi4xODQgLTEyLC02YzEuMjI0LC0wLjY4MSAyLjE1NiwtMS43ODggMi42MiwtMy4xMWMxLjI0OCwwLjgyNSAyLjU5MSwxLjQ5NiA0LDJjMy40OSwxLjIzNCA3LjMsMS4yMzQgMTAuNzksMGMxLjQwNywtMC41MDcgMi43NSwtMS4xNzggNCwtMmMwLjQ1NiwxLjMzOSAxLjM5NCwyLjQ2MSAyLjYzLDMuMTVjLTIuODEyLDMuODEyIC03LjMwNCw2LjAzNSAtMTIuMDQsNS45NmwwLDBaTTIzLjAxLDM4LjExN2MtMSwtMy40OCAtMC41NywtNC43NCAtMC4yMywtNS4xOGMwLjI0MSwtMC4zIDAuNjE3LC0wLjQ1OCAxLC0wLjQybDAuMTgsMGMwLjI4NywwLjAxNyAwLjUzOCwtMC4yMDMgMC41NiwtMC40OWMwLC0wLjA4IDAuNjIsLTcuNTcgNS4wNiwtMTAuMjdjMi4yMiwtMS4zNSA1LjA3LC0xLjMgOC40NywwLjE1YzcsMyAxMi4xNCwyLjc4IDE1LjI5LDIuMDhjMy42LDIuNjUgMi41Niw2LjkgMi4zMiw3LjcybDAsMC4xYy0wLjA2LDAuMTY5IC0wLjAzLDAuMzU4IDAuMDgsMC41YzAuMTEyLDAuMTQyIDAuMjg5LDAuMjE4IDAuNDcsMC4yYzAuNDQsLTAuMDgzIDAuODk0LDAuMDczIDEuMTksMC40MWMwLjMzLDAuNDQgMC43NSwxLjcgLTAuMjMsNS4xOGMtMS4yNiw0LjQ2IC0yLjI5LDQuODggLTIuNTcsNC45Yy0wLjI0NiwwLjAxNyAtMC40NDgsMC4yMDYgLTAuNDgsMC40NWMtMC43Myw0Ljc1IC00LjUxLDEwLjY1IC0xMC4zMSwxMi43NGMtMi40MDYsMC44NTQgLTUuMDM0LDAuODU0IC03LjQ0LDBjLTYsLTIuMTMgLTkuNTYsLTguMSAtMTAuMjgsLTEyLjc2Yy0wLjAzNiwtMC4yNDIgLTAuMjM2LC0wLjQzIC0wLjQ4LC0wLjQ1Yy0wLjMxLDAuMDIgLTEuMzQsLTAuNDEgLTIuNiwtNC44NloiIHN0eWxlPSJmaWxsOiM4MDgwODA7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+" riot-src="{\'/images/avatars/\'+user_id+\'.jpg/rs-40x40a.jpg\'}"></div> <div class="bubble"><small>{first_name || ⁗Guest⁗}<span class="subtle">{time(when)}</span></small>{message}</div> </li> </ul> </div> <form onsubmit="{send}"> <div class="form-group"> <div class="input-group"> <input name="message" placeholder="your message" class="input-sm form-control"><span class="input-group-btn"> <button type="submit" class="btn btn-primary btn-sm">Send</button></span> </div> </div> </form> </div> <div if="{!active}"> <a onclick="{activate}" class="btn btn-default">Chat <div class="fa fa-comment"></div></a></div>', 'chat.fixed { width: 320px; } @media (max-width: 640px) { chat.fixed { width: auto; left: 5px; } } chat { background: rgba(248,248,248,0.7); display: block; padding: 10px; border-radius: 4px; -webkit-box-shadow: 0 3px 20px rgba(0,0,0,0.2); box-shadow: 0 3px 20px rgba(0,0,0,0.2); position: fixed; bottom: 5px; right: 5px; z-index: 1000; } chat h4 { margin: 5px 0; } chat .close { position: absolute; top: 10px; right: 10px; } chat .chatlist { background: #fff; overflow: auto; max-height: 300px; min-height: 200px; padding: 10px 10px 0 10px; border: 1px solid #ddd; } chat ul, chat li { margin: 0; padding: 0; clear: both; } chat li { margin-bottom: 10px; } chat small { display: block; font-size: 11px; line-height: 12px; margin-bottom: 5px; font-weight: bold; } chat small .subtle { color: #888; font-weight: normal; margin-left: 10px; } chat .form-group { margin: 5px 0; } chat .bubble { padding: 0 10px 10px 15px; position: relative; margin-left: 35px; font-size: 12px; line-height: 14px; } chat .imageblock { border-radius: 4px; overflow: hidden; float: left; } chat .imageblock img { width: 40px; height: 40px; }', 'class="{active ? \'fixed\' : \'full\'}"', function(opts) {
var Sockets;

Sockets = require("../sockets.coffee");

this.messages = [];

this.activate = (function(_this) {
  return function() {
    window.localStorage.chat_active = true;
    _this.active = true;
    return setTimeout(function() {
      return _this.scrollToBottom();
    });
  };
})(this);

this.deactivate = (function(_this) {
  return function() {
    window.localStorage.chat_active = false;
    return _this.active = false;
  };
})(this);

this.send = (function(_this) {
  return function(e) {
    var csrf, data, xhr;
    e.preventDefault();
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        return _this.message.value = "";
      }
    };
    xhr.open('POST', "/duocms/api/sales/chat", true);
    csrf = window.csrf;
    xhr.setRequestHeader("x-csrf-token", csrf);
    xhr.setRequestHeader("Content-Type", "application/json");
    data = JSON.stringify({
      message: _this.message.value
    });
    return xhr.send(data);
  };
})(this);

this.scrollToBottom = (function(_this) {
  return function() {
    var list;
    list = _this.root.querySelector('.chatlist');
    if (list) {
      return list.scrollTop = list.scrollHeight;
    }
  };
})(this);

this.on('mount', (function(_this) {
  return function() {
    _this.visible = opts.visible != null;
    _this.update({
      active: window.localStorage.chat_active === "true"
    });
    if (!_this.socket) {
      _this.socket = new Sockets();
    }
    _this.socket.on("chat:updated", function(data) {
      _this.messages.push(data);
      _this.active = true;
      _this.update();
      return _this.scrollToBottom();
    });
    _this.socket.on("chat:visible", function(data) {
      _this.visible = data;
      return _this.update();
    });
    return _this.loadall();
  };
})(this));

this.time = (function(_this) {
  return function(date) {
    var ampm, dt, hr, min;
    dt = new Date(date.replace(/\+/, "."));
    if (dt.getHours() > 12) {
      hr = dt.getHours() - 12;
      ampm = "PM";
    } else {
      hr = dt.getHours();
      ampm = "AM";
    }
    min = ("00" + dt.getMinutes()).substr(-2);
    return hr + ":" + min + " " + ampm;
  };
})(this);

this.on('updated', (function(_this) {
  return function() {
    var bubbles;
    bubbles = [].slice.call(_this.root.querySelectorAll(".bubble span"));
    bubbles.forEach(function(bubble) {
      var notags, withLinks;
      notags = bubble.innerHTML.replace(/<[^>]*>/g, "");
      withLinks = notags.replace(/(https?:\/\/|www\.)([^\s<]+)/g, function(link) {
        if (link.match(/^https?:\/\//)) {
          return '<a href="' + link + '">' + link + '</a>';
        } else {
          return '<a href="http://' + link + '">' + link + '</a>';
        }
      });
      if (withLinks !== bubble.innerHTML) {
        return bubble.innerHTML = withLinks;
      }
    });
    return _this.root.style.display = _this.visible ? 'block' : 'none';
  };
})(this));

this.loadall = (function(_this) {
  return function() {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      var er;
      if (xhr.readyState === 4) {
        try {
          _this.messages = JSON.parse(xhr.responseText).data;
          _this.update();
          return _this.scrollToBottom();
        } catch (error) {
          er = error;
          return console.log("error getting chat");
        }
      }
    };
    xhr.open('GET', "/duocms/api/sales/mychat", true);
    return xhr.send();
  };
})(this);
});
    
  